const groupCommissionItems = (items) => {
    const groupsMap = new Map();

    for (const item of items) {
        const key = item.commissionGroupName || '__unassigned__';
        let group = groupsMap.get(key);
        if (!group) {
            group = {
                commissionGroupName: item.commissionGroupName || 'No Commission Group Assigned',
                lineTotal: 0,
                commissionAmount: 0,
                items: [],
            };
            groupsMap.set(key, group);
        }
        group.lineTotal += item.lineTotal;
        group.commissionAmount += item.commissionAmount;
        group.items.push(item);
    }

    return Array.from(groupsMap.values()).sort((a, b) =>
        a.commissionGroupName.localeCompare(b.commissionGroupName),
    );
};

export default groupCommissionItems;
